import Hourglass from "./contracts/Hourglass.json";

import metacoinConfig from "./metacoin-config";

var contractAddress;
var tronWeb;
try {
  const TronWeb = require("tronweb");

  window.addEventListener("load", async event => {
    tronWeb = window.tronWeb;
    contract_obj.tronWebProvider = window.tronWeb;
    console.log("page is fully loaded", window.tronWeb, tronWeb);
    var node_ =
      window.tronWeb &&
      (window.tronWeb.fullNode.host == "https://api.shasta.trongrid.io"
        ? "shasta"
        : "mainnet");
    if (node_) {
      contractAddress = metacoinConfig[node_].contractAddress;
      console.log(contractAddress, "contractAddress");
      contract_obj.init(node_);
    }
  });
  // document.write(window.tronWeb.defaultAddress.base58)
} catch (err) {
  // alert(`The app looks not configured. Please run "npm run migrate" ${err}`);
}

const contract_obj = {
  tronWebProvider: tronWeb,
  contracts: {},
  accounts: [],
  contractAddress: contractAddress,
  // privateKey:
  //   "CBB6FDC134599AD3FF5D8E4A23E87EB1289BC6985A3380D8FAA35CDBA677DA05",
  feeLimit: 100000000,
  callValue: 0,
  abi: {
    entrys: [
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_customerAddress", type: "address" }],
        name: "dividendsOf",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "string" }],
        constant: true,
        name: "name",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        inputs: [
          { name: "spender", type: "address" },
          { name: "value", type: "uint256" },
        ],
        name: "approve",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "calculateTokensReinvested",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_amountOfTokens", type: "uint256" }],
        name: "calculateTronTransferred",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_tronToSpend", type: "uint256" }],
        name: "calculateTokensReceived",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "totalSupply",
        stateMutability: "View",
        type: "Function",
      },
      {
        inputs: [
          { name: "period", type: "uint24" },
          { name: "rewardPerInvocation", type: "uint256" },
          { name: "minimumDividendValue", type: "uint256" },
        ],
        name: "setupAutoReinvest",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        inputs: [
          { name: "sender", type: "address" },
          { name: "recipient", type: "address" },
          { name: "amount", type: "uint256" },
        ],
        name: "transferFrom",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        inputs: [{ name: "ref_name", type: "bytes32" }],
        name: "setReferralName",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        constant: true,
        name: "onlyAmbassadors",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "address" }],
        constant: true,
        inputs: [{ name: "ref_name", type: "bytes32" }],
        name: "getReferralAddressForName",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint8" }],
        constant: true,
        name: "decimals",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }, { type: "uint256" }],
        constant: true,
        name: "getCursor",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        inputs: [
          { name: "spender", type: "address" },
          { name: "addedValue", type: "uint256" },
        ],
        name: "increaseAllowance",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      { name: "withdraw", stateMutability: "Nonpayable", type: "Function" },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [
          { name: "_amountOfTokens", type: "uint256" },
          { name: "_customerAddress", type: "address" },
        ],
        name: "calculateAveragePenalty",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "address" }],
        constant: true,
        inputs: [{ type: "bytes32" }],
        name: "referralReverseMapping",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "sellPrice",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }, { type: "uint256" }],
        constant: true,
        name: "getReferralBalance",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_tron", type: "uint256" }],
        name: "tronToTokens_",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "stakingRequirement",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [
          { type: "uint256" },
          { type: "uint256" },
          { type: "uint256" },
        ],
        constant: true,
        inputs: [{ name: "counter", type: "uint256" }],
        name: "getTimestampedBalanceLedger",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        constant: true,
        inputs: [{ type: "address" }],
        name: "ambassadors_",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [
          { name: "l", type: "uint256" },
          { name: "h", type: "uint256" },
        ],
        constant: true,
        inputs: [
          { name: "x", type: "uint256" },
          { name: "y", type: "uint256" },
        ],
        name: "fullMul",
        stateMutability: "Pure",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_includeReferralBonus", type: "bool" }],
        name: "myDividends",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bytes32" }],
        constant: true,
        inputs: [{ type: "address" }],
        name: "referralMapping",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ type: "address" }],
        name: "referralIncome_",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bytes32" }],
        constant: true,
        inputs: [{ name: "ref_address", type: "address" }],
        name: "getReferralNameForAddress",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_customerAddress", type: "address" }],
        name: "balanceOf",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        constant: true,
        inputs: [{ type: "address" }],
        name: "administrators",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "timestamp", type: "uint256" }],
        name: "_calculatePenalty",
        stateMutability: "View",
        type: "Function",
      },
      {
        inputs: [{ name: "_amountOfTokens", type: "uint256" }],
        name: "setStakingRequirement",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "buyPrice",
        stateMutability: "View",
        type: "Function",
      },
      {
        inputs: [
          { name: "_identifier", type: "address" },
          { name: "_status", type: "bool" },
        ],
        name: "setAdministrator",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_tokensToSell", type: "uint256" }],
        name: "calculateTronReceived",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        inputs: [{ name: "_customerAddress", type: "address" }],
        name: "invokeAutoReinvest",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "myTokens",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "string" }],
        constant: true,
        name: "symbol",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        inputs: [
          { name: "spender", type: "address" },
          { name: "subtractedValue", type: "uint256" },
        ],
        name: "decreaseAllowance",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [
          { type: "uint256" },
          { type: "uint256" },
          { type: "uint24" },
          { type: "uint256" },
        ],
        constant: true,
        inputs: [{ name: "_customerAddress", type: "address" }],
        name: "getAutoReinvestEntryOf",
        stateMutability: "View",
        type: "Function",
      },
      {
        name: "disableInitialStage",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "bool" }],
        inputs: [
          { name: "_toAddress", type: "address" },
          { name: "_amountOfTokens", type: "uint256" },
        ],
        name: "transfer",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [
          { name: "x", type: "uint256" },
          { name: "y", type: "uint256" },
          { name: "z", type: "uint256" },
        ],
        name: "mulDiv",
        stateMutability: "Pure",
        type: "Function",
      },
      {
        inputs: [{ name: "_symbol", type: "string" }],
        name: "setSymbol",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        name: "stopAutoReinvest",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        inputs: [{ name: "_name", type: "string" }],
        name: "setName",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ type: "address" }],
        name: "referralBalance_",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [{ name: "_tokens", type: "uint256" }],
        name: "tokensToTron_",
        stateMutability: "View",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        inputs: [
          { name: "owner", type: "address" },
          { name: "spender", type: "address" },
        ],
        name: "allowance",
        stateMutability: "View",
        type: "Function",
      },
      {
        inputs: [{ name: "_amountOfTokens", type: "uint256" }],
        name: "sell",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      { name: "exit", stateMutability: "Nonpayable", type: "Function" },
      {
        outputs: [
          { type: "uint256" },
          { type: "uint256" },
          { type: "uint24" },
          { type: "uint256" },
        ],
        constant: true,
        name: "getAutoReinvestEntry",
        stateMutability: "View",
        type: "Function",
      },
      {
        inputs: [
          { name: "isAutoReinvestChecked", type: "bool" },
          { name: "period", type: "uint24" },
          { name: "rewardPerInvocation", type: "uint256" },
          { name: "minimumDividendValue", type: "uint256" },
        ],
        name: "reinvest",
        stateMutability: "Nonpayable",
        type: "Function",
      },
      {
        payable: true,
        inputs: [{ name: "_referredBy", type: "address" }],
        name: "buy",
        stateMutability: "Payable",
        type: "Function",
      },
      {
        outputs: [{ type: "uint256" }],
        constant: true,
        name: "totalTronBalance",
        stateMutability: "View",
        type: "Function",
      },
      { stateMutability: "Nonpayable", type: "Constructor" },
      { payable: true, stateMutability: "Payable", type: "Fallback" },
      {
        inputs: [
          { indexed: true, name: "customerAddress", type: "address" },
          { name: "incomingTron", type: "uint256" },
          { name: "tokensMinted", type: "uint256" },
          { indexed: true, name: "referredBy", type: "address" },
        ],
        name: "onTokenPurchase",
        type: "Event",
      },
      {
        inputs: [
          { indexed: true, name: "customerAddress", type: "address" },
          { name: "tokensBurned", type: "uint256" },
          { name: "tronEarned", type: "uint256" },
        ],
        name: "onTokenSell",
        type: "Event",
      },
      {
        inputs: [
          { indexed: true, name: "customerAddress", type: "address" },
          { name: "tronReinvested", type: "uint256" },
          { name: "tokensMinted", type: "uint256" },
        ],
        name: "onReinvestment",
        type: "Event",
      },
      {
        inputs: [
          { indexed: true, name: "customerAddress", type: "address" },
          { name: "tronWithdrawn", type: "uint256" },
        ],
        name: "onWithdraw",
        type: "Event",
      },
      {
        inputs: [
          { indexed: true, name: "from", type: "address" },
          { indexed: true, name: "to", type: "address" },
          { name: "tokens", type: "uint256" },
        ],
        name: "Transfer",
        type: "Event",
      },
      {
        inputs: [
          { indexed: true, name: "owner", type: "address" },
          { indexed: true, name: "spender", type: "address" },
          { name: "value", type: "uint256" },
        ],
        name: "Approval",
        type: "Event",
      },
      {
        inputs: [
          { indexed: true, name: "customerAddress", type: "address" },
          { name: "nextExecutionTime", type: "uint256" },
          { name: "rewardPerInvocation", type: "uint256" },
          { name: "period", type: "uint24" },
          { name: "minimumDividendValue", type: "uint256" },
        ],
        name: "onAutoReinvestmentEntry",
        type: "Event",
      },
      {
        inputs: [{ indexed: true, name: "customerAddress", type: "address" }],
        name: "onAutoReinvestmentStop",
        type: "Event",
      },
    ],
  },
  contract_instace: null,
  init: async function (node_) {
    // console.log(node_,"NODE",metacoinConfig[node_].contractAddress)
    if (node_) {
      contract_obj.contractAddress = metacoinConfig[node_].contractAddress;
      contract_obj.contract_instace =
        node_ && tronWeb && (await tronWeb.contract().at(this.contractAddress));
    }
    this.accounts = [
      this.tronWebProvider && this.tronWebProvider.defaultAddress.base58,
    ];
  },
  buyFunc: async function (trx, ref) {
    // await this.init()
    var ref_by = ref ? ref : this.accounts[0];
    // console.log(this.contract_instace, "nnnn", trx, ref_by , this.accounts[0]);
    var data = await this.contract_instace
      .buy(ref_by)
      .send({
        feeLimit: this.feeLimit,
        callValue: trx,
        // shouldPollResponse : true
      })
      .then(function (res) {
        if (res) {
          // console.log(res, "tt11");
        }
      });
  },
  refFunc: async function (hex_str) {
    console.log("ref_str",typeof(hex_str) )
    await this.contract_instace
      .setReferralName(hex_str)
      .send({
        feeLimit: this.feeLimit,
      })
      .then(function (res) {
        if (res) {
          // console.log(res.toString(), "refff");
        }
      });
  },
  reinvestFunc: async function (
    autoReinvest,
    period,
    rewardPerInvocation,
    minimumDividendValue
  ) {
    const period_ = period;
    const rewardPerInvocation_ = rewardPerInvocation * 1e6;
    const minimumDividendValue_ = minimumDividendValue * 1e6;

    await this.contract_instace
      .reinvest(
        autoReinvest,
        period_,
        rewardPerInvocation_,
        minimumDividendValue_
      )
      .send({
        feeLimit: this.feeLimit,
      })
      .then(function (res) {
        if (res) {
          // console.log(res.toString(), "reinvest");
          return res
        }
      });
  },
  stopAutoReinvestFunc: async function () {
    await this.contract_instace
      .stopAutoReinvest()
      .send({
        feeLimit: this.feeLimit,
      })
      .then(function (res) {
        if (res) {
          return res

          // console.log(res.toString(), "stopAutoReinvestFunc");
        }
      });
  },
  withdrawFunc: async function () {
    await this.contract_instace
      .withdraw()
      .send({
        feeLimit: this.feeLimit,
      })
      .then(function (res) {
        if (res) {
          // console.log(res.toString(), "withdraw");
        }
      });
  },
  sellFunc: async function (ceto) {
    console.log(ceto, "ll");
    var ceto_to_sell = ceto * 1e6;
    await this.contract_instace
      .sell(ceto_to_sell)
      .send({
        feeLimit: this.feeLimit,
      })
      .then(function (res) {
        if (res) {
          // console.log(res.toString(), "sell");
        }
      });
  },
  transferFunc: async function (address, ceto) {
    var ceto_to_transfer = ceto * 1e6;

    await this.contract_instace
      .transfer(address, ceto_to_transfer)
      .send({
        feeLimit: this.feeLimit,
      })
      .then(function (res) {
        if (res) {
          console.log(res.toString(), "transferred");
        }
      });
  },
  getTokensFunc: async function () {
    var my_tokens = await this.contract_instace
      .myTokens()
      .call({
        from: this.accounts[0],
        feeLimit: this.feeLimit,
        callValue: this.callValue || 0,
      })
      .then(function (res) {
        if (res) {
          return Promise.resolve(res.toString());
        }
      });
  },
};

export default contract_obj;
